import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logo_small.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
}, null, -1)
const _hoisted_2 = ["dir"]
const _hoisted_3 = { class: "container-fluid max-width-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: '/'
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "FlashFox VPN logo"
  })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav ml-auto mr-auto" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = ["dir"]
const _hoisted_10 = { class: "container-fluid navbar-menu" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: '/'
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo img-fluid",
    src: _imports_0,
    alt: "FlashFox VPN logo"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "mob-responsive-nav",
  id: "navbarSupportedContent"
}
const _hoisted_15 = { class: "navbar-nav ml-auto ml-0" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = {
  class: "nav-link",
  href: '/'
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = {
  class: "nav-link",
  href: '/tutorials?p=2'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FadeDown = _resolveComponent("FadeDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("nav", {
      class: _normalizeClass(["nav navbar navbar-expand-md navbar-dark nav py-2 sticky-top hide-on-mobile p-0 px-md-5", _ctx.direction == 'rtl'?'rtl-lang':'']),
      id: "nav",
      ref: "nav",
      dir: _ctx.direction
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: "nav-link",
                href: '/?p=1',
                onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseOver && _ctx.handleMouseOver(...args))),
                onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.p == '1' /* && !data.hover */?'nav-item-selected':'')
                }, _toDisplayString(_ctx.locale.home), 3)
              ], 32)
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: "nav-link",
                href: '/tutorials?p=2',
                onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseOver && _ctx.handleMouseOver(...args))),
                onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.p == '2' /* && !data.hover */?'nav-item-selected':'')
                }, _toDisplayString(_ctx.locale.support), 3)
              ], 32)
            ])
          ])
        ])
      ])
    ], 10, _hoisted_2),
    _createElementVNode("nav", {
      class: _normalizeClass(["nav navbar navbar-expand-md navbar-dark nav inner-menu d-md-none py-2 sticky-top", _ctx.direction == 'rtl'?'rtl-lang':'']),
      id: "nav",
      dir: _ctx.direction
    }, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("button", {
          class: "navbar-toggler alignRight",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toggleMobileMenu()), ["prevent"]))
        }, _hoisted_13),
        _createVNode(_component_FadeDown, null, {
          default: _withCtx(() => [
            (_ctx.isMobNavShown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", _hoisted_16, [
                      _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.locale.home), 1)
                    ]),
                    _createElementVNode("li", _hoisted_18, [
                      _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.locale.support), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ], 10, _hoisted_9)
  ], 64))
}